// @ts-nocheck
import { useGLTF, useTexture, Plane, Box, Svg } from '@react-three/drei'
import React, { useRef } from 'react'
import * as THREE from 'three'

const texture1 = `${process.env.PUBLIC_URL}/assets/images/glasses/page3a-frame.png`;
const svg2 = `${process.env.PUBLIC_URL}/assets/images/glasses/page3a-arm.svg`;


export default function Model(props) {
  const group = useRef()
  const bodyTex  = useTexture(texture1)

  return (
    <group ref={group} {...props} dispose={null} position-y={0.25} scale={.85}>

      <Svg src={svg2} scale={.001} position={[-1.4,0.15,-1.82]} rotation={[0, -Math.PI/2, 0]}/>
      <Svg src={svg2} scale={.001} position={[1.4,0.15,-1.82]} rotation={[0, -Math.PI/2, 0]}/>


      <Plane args={[3.315, 1.535]} 
      position={[0,-0.1,0]}
      >
         <meshBasicMaterial  map={bodyTex} side={THREE.DoubleSide} alphaTest={0.1}
         transparent 
         />
      </Plane>

      {/*
      <Plane args={[2.15, 0.485]} 
      position={[-1.4,-0.1,-1.0]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
      <Plane args={[2.15, 0.485]}  
      position={[1.4,-0.1,-1.0]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
  */}
     

    </group>
  )
}

